module.exports = __webpack_public_path__ + "img/map-marker-lh.7ec85909.png";